/* eslint-disable no-restricted-globals */
export default {
    callable() {
        focus();

        const listener = () => {
            if (document.activeElement === document.getElementById('iframe')) {
                const imageElement = document.querySelector('[data-click-src]');
                if (imageElement) {
                    imageElement.setAttribute(
                        'src',
                        imageElement.getAttribute('data-click-src') || ''
                    );
                }
            }
            removeEventListener('blur', listener);
        };
        addEventListener('blur', listener);
    },
};
